(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eh-header"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('eh-marquee')){customElements.define('eh-marquee',class extends HTMLElement{connectedCallback(){this.querySelector('button')?.addEventListener('click',event=>{const button=event.currentTarget;const paused=this.dataset.paused!=='true';this.dataset.paused=String(paused);button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?button.dataset.playLabel:button.dataset.pauseLabel)})}})}
document.addEventListener('click',event=>{const link=event.target.closest('.eh-menu a');if(link)link.closest('details').open=false});
if(!window.ehRevealReady){window.ehRevealReady=true;const observe=root=>{if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}})},{threshold:.08,rootMargin:'0px 0px -20px 0px'});root.querySelectorAll('.eh-reveal:not(.eh-reveal--ready)').forEach(element=>{element.classList.add('eh-reveal--ready');observer.observe(element)})};observe(document);document.addEventListener('shopify:section:load',event=>observe(event.target))}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eh-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eh-product')) {
    customElements.define('eh-product', class extends HTMLElement {
      connectedCallback() {
        this.lifecycle?.abort();
        this.lifecycle = new AbortController();
        const options = { signal: this.lifecycle.signal };
        this.quantityInput = this.querySelector('input[name="quantity"]');
        this.variantInputs = Array.from(this.querySelectorAll('[data-eh-variant]'));
        this.animate = this.classList.contains('eh-product--animate') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.variantInputs.forEach(input => input.addEventListener('change', () => this.updateVariant(), options));
        this.querySelectorAll('[data-show-image]').forEach(button => button.addEventListener('click', () => this.showImage(button.dataset.showImage), options));
        this.galleryImages = Array.from(this.querySelectorAll('[data-image-id]'));
        this.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => this.stepImage(Number(button.dataset.galleryStep)), options));
        this.querySelector('[data-gallery-slider]')?.addEventListener('input', event => this.showImage(this.galleryImages[Number(event.target.value) - 1]?.dataset.imageId), options);
        const gallery = this.querySelector('[data-gallery-swipe]');
        gallery?.addEventListener('keydown', event => {
          if (event.target !== gallery || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.stepImage(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        gallery?.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.target.closest('button') || (event.pointerType === 'mouse' && event.button !== 0)) return;
          this.galleryGesture = { x: event.clientX, y: event.clientY, id: event.pointerId };
        }, options);
        gallery?.addEventListener('pointerup', event => {
          const start = this.galleryGesture;
          this.galleryGesture = null;
          if (!start || start.id !== event.pointerId) return;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.4) this.stepImage(dx < 0 ? 1 : -1);
        }, options);
        gallery?.addEventListener('pointercancel', () => { this.galleryGesture = null; }, options);
        this.updateGalleryNavigation();
        this.querySelectorAll('[data-quantity-preset]').forEach(button => button.addEventListener('click', () => {
          this.quantityInput.value = button.dataset.quantityPreset;
          this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }, options));
        this.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
          const input = this.quantityInput;
          const step = Number(input.step) || 1;
          const min = Number(input.min) || 1;
          const max = input.max ? Number(input.max) : Infinity;
          input.value = Math.min(max, Math.max(min, (Number(input.value) || min) + Number(button.dataset.quantityStep) * step));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }, options));
        this.quantityInput?.addEventListener('input', () => this.updateQuantity(), options);
        this.quantityInput?.addEventListener('change', () => this.updateQuantity(), options);
        const mainButton = this.querySelector('[data-eh-main-add]');
        const mobileBar = this.querySelector('[data-eh-mobile-bar]');
        if (mainButton && mobileBar) {
          mobileBar.hidden = false;
          this.observer?.disconnect();
          this.observer = new IntersectionObserver(entries => {
            const entry = entries[0];
            mobileBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom <= 0);
          }, { threshold: 0 });
          this.observer.observe(mainButton);
        }
        this.updateQuantity();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.lifecycle?.abort();
        window.clearTimeout(this.imageTimer);
      }
      get selectedVariant() { return this.variantInputs.find(input => input.checked); }
      stepImage(direction) {
        const images = this.galleryImages || [];
        if (images.length < 2) return;
        const current = Math.max(0, images.findIndex(image => image.classList.contains('is-active')));
        this.showImage(images[(current + direction + images.length) % images.length].dataset.imageId);
      }
      updateGalleryNavigation() {
        const images = this.galleryImages || [];
        const index = Math.max(0, images.findIndex(image => image.classList.contains('is-active')));
        const slider = this.querySelector('[data-gallery-slider]');
        if (slider) slider.value = String(index + 1);
        const count = this.querySelector('[data-gallery-count]');
        if (count) count.textContent = (index + 1) + ' / ' + images.length;
        const thumbnails = this.querySelector('.eh-product__thumbnails');
        const active = this.querySelector('[data-show-image][aria-pressed="true"]');
        if (thumbnails && active) thumbnails.scrollTo({ left: active.offsetLeft - thumbnails.offsetLeft - (thumbnails.clientWidth - active.offsetWidth) / 2, behavior: this.animate ? 'smooth' : 'auto' });
      }
      showImage(id) {
        const next = Array.from(this.querySelectorAll('[data-image-id]')).find(image => image.dataset.imageId === id);
        if (!next) return;
        const current = this.querySelector('.eh-product__image.is-active');
        if (next === current) return;
        window.clearTimeout(this.imageTimer);
        this.querySelectorAll('[data-image-id]').forEach(image => {
          if (image !== next && image !== current) { image.hidden = true; image.classList.remove('is-active'); }
        });
        next.hidden = false;
        if (!this.animate) {
          current?.classList.remove('is-active');
          if (current) current.hidden = true;
          next.classList.add('is-active');
        } else {
          next.getBoundingClientRect();
          current?.classList.remove('is-active');
          next.classList.add('is-active');
          this.imageTimer = window.setTimeout(() => { if (current && !current.classList.contains('is-active')) current.hidden = true; }, 340);
        }
        this.querySelectorAll('[data-show-image]').forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.showImage === id)); });
        this.updateGalleryNavigation();
      }
      updateVariant() {
        const variant = this.selectedVariant;
        if (!variant) return;
        this.querySelectorAll('[data-eh-price]').forEach(element => { element.textContent = variant.dataset.price; });
        this.querySelectorAll('[data-eh-add]').forEach(button => {
          button.disabled = variant.dataset.available !== 'true';
          button.querySelector('[data-eh-add-label]').textContent = button.disabled ? this.dataset.unavailableLabel : this.dataset.addLabel;
        });
        const input = this.quantityInput;
        input.min = variant.dataset.min || '1';
        input.step = variant.dataset.step || '1';
        if (variant.dataset.max) input.max = variant.dataset.max;
        else input.removeAttribute('max');
        const min = Number(input.min);
        const step = Number(input.step);
        const max = input.max ? Number(input.max) : Infinity;
        input.value = Math.min(max, Math.max(min, min + Math.round(((Number(input.value) || min) - min) / step) * step));
        this.querySelectorAll('[data-quantity-preset]').forEach(button => {
          const quantity = Number(button.dataset.quantityPreset);
          button.disabled = quantity < min || quantity > max || (quantity - min) % step !== 0;
          button.querySelector('[data-preset-total]').textContent = variant.dataset['total-' + quantity];
        });
        this.updateQuantity();
        this.showImage(variant.dataset.image);
      }
      updateQuantity() {
        const variant = this.selectedVariant;
        if (!variant || !this.quantityInput) return;
        const quantity = Number(this.quantityInput.value);
        this.querySelectorAll('[data-quantity-preset]').forEach(button => { button.setAttribute('aria-pressed', String(Number(button.dataset.quantityPreset) === quantity)); });
        if (!Number.isInteger(quantity) || quantity < 1) return;
        const total = this.moneyFor(quantity);
        this.querySelectorAll('[data-eh-total]').forEach(element => { element.textContent = total; });
        this.querySelectorAll('[data-eh-quantity-summary]').forEach(element => { element.textContent = quantity + ' ' + this.dataset.quantityUnit; });
        this.updateSavings(quantity);
      }
      moneyFor(quantity, kind = 'total') {
        const variant = this.selectedVariant;
        const nativeAmount = variant.dataset[kind + '-' + quantity];
        if (nativeAmount) return nativeAmount;
        const price = Number(variant.dataset.priceCents);
        const compare = Number(variant.dataset.comparePriceCents) || 0;
        let unitAmount = price;
        if (kind === 'compare') unitAmount = compare;
        if (kind === 'savings') unitAmount = Math.max(0, compare - price);
        return new Intl.NumberFormat(this.dataset.locale || 'pl', { style: 'currency', currency: this.dataset.currency }).format(unitAmount * quantity / 100);
      }
      updateSavings(quantity) {
        const variant = this.selectedVariant;
        const price = Number(variant.dataset.priceCents);
        const compare = Number(variant.dataset.comparePriceCents) || 0;
        const active = this.dataset.showSavings === 'true' && compare > price;
        this.querySelectorAll('[data-eh-compare-price]').forEach(element => {
          element.hidden = !active;
          if (active) element.textContent = variant.dataset.comparePrice;
        });
        this.querySelectorAll('[data-eh-discount-percent]').forEach(element => {
          element.hidden = !active;
          if (active) element.textContent = '−' + Math.round((compare - price) / compare * 100) + '%';
        });
        this.querySelectorAll('[data-eh-lowest-price], [data-eh-selection-savings]').forEach(element => { element.hidden = !active; });
        this.querySelectorAll('[data-eh-compare-total]').forEach(element => {
          element.hidden = !active;
          if (active) element.textContent = this.moneyFor(quantity, 'compare');
        });
        this.querySelectorAll('[data-eh-savings-total]').forEach(element => {
          if (active) element.textContent = this.moneyFor(quantity, 'savings');
        });
        this.querySelectorAll('[data-quantity-preset]').forEach(button => {
          const rowQuantity = Number(button.dataset.quantityPreset);
          button.querySelector('[data-preset-total]').textContent = this.moneyFor(rowQuantity);
          const rowCompare = button.querySelector('[data-preset-compare]');
          rowCompare.hidden = !active;
          button.querySelector('[data-preset-savings-row]').hidden = !active;
          if (active) {
            rowCompare.textContent = this.moneyFor(rowQuantity, 'compare');
            button.querySelector('[data-preset-savings]').textContent = this.moneyFor(rowQuantity, 'savings');
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
